export default {
  url: {
    CenterName: '服务中心名称',
    CenterCode: '服务中心编码',
    ServiceName: '服务名称',
    ServiceCode: '服务编码',
    ModuleName: '模块名称',
    ModuleCode: '模块编码',
    TypeName: '类名称',
    AccessUrl: '链接地址',
    AccessMethod: '访问方式',
    ClassMethod: '类方法',
    ClassName: '类名称',
    MenuId: '菜单Id',
    MenuName: '菜单名称',
    FunctId: '功能Id',
    FunctName: '功能名称',
    MatchPath: '匹配路径',
    AccessAddress: '访问地址',
    TypeMethod: '类方法'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/base/url.js